/* src/app/modules_v2/income/grant/components/grant-form/grant-form.component.css */
.gf-form {
  padding-bottom: 2rem;
}
.gf-budget-table {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.gf-budget-row {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 0.6fr;
  gap: 12px;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
}
.gf-budget-row--head {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--cf-text-muted, #6b7280);
}
.gf-budget-row mat-form-field,
.gf-budget-row app-field {
  width: 100%;
}
.tf-card mat-card-content {
  padding: 1rem 1.25rem !important;
}
.tf-section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 0.75rem;
}
.tf-section-title {
  font-weight: 600;
  font-size: 0.95rem;
  color: #1f2937;
  margin: 0;
}
.ef-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--cf-bg, #f4f6f8);
  font-family: "Inter Tight", sans-serif;
}
.ef-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  background: var(--cf-surface, #fff);
  border-bottom: 1px solid var(--cf-border, #e5e7eb);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}
.ef-header__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.ef-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--cf-brand-dark);
}
.ef-header__title {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
  line-height: 1.3;
}
.ef-header__sub {
  margin: 0;
  font-size: 0.78rem;
  color: var(--cf-text-muted, #6b7280);
}
.ef-btn-save {
  background: var(--cf-brand, #e3fd64) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(227, 253, 100, 0.25) !important;
  white-space: nowrap;
}
.ef-btn-save:hover:not([disabled]) {
  background: var(--cf-brand-dark, #4d7a00) !important;
}
.ef-body {
  padding: 14px 20px;
  flex: 1;
}
.ef-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
}
.pf-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
.pf-btn-cancel {
  border-radius: 8px !important;
  white-space: nowrap;
}
.pf-side-by-side {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: stretch;
  margin-bottom: 1rem;
}
.pf-side-by-side > .tf-card {
  height: 100%;
}
.pf-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0 16px;
}
.pf-grid-2 > * {
  min-width: 0;
}
.gf-hint {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin: -4px 0 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid var(--cf-border, #e5e7eb);
  color: var(--cf-text-muted, #6b7280);
  font-size: 12.5px;
  line-height: 1.4;
}
.gf-hint mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
}
.gf-file-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.gf-file-input {
  display: none;
}
.gf-btn {
  height: 36px !important;
  padding: 0 14px !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  color: #1a1d23 !important;
  background: #fff !important;
  border: 1px solid var(--cf-border, #e5e7eb) !important;
  box-shadow: none !important;
}
.gf-btn:hover:not([disabled]) {
  background: #f9fafb !important;
  border-color: #c5d94a !important;
}
.gf-btn--danger {
  color: #b91c1c !important;
}
.gf-btn--danger:hover:not([disabled]) {
  border-color: #fca5a5 !important;
  background: #fef2f2 !important;
}
.gf-btn mat-icon {
  font-size: 18px !important;
  width: 18px !important;
  height: 18px !important;
  margin-right: 4px;
}
.gf-file-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 160px;
  border: 1px dashed var(--cf-border, #e5e7eb);
  border-radius: 10px;
  color: var(--cf-text-muted, #6b7280);
  font-size: 13px;
  text-align: center;
  padding: 16px;
}
.gf-file-empty mat-icon {
  font-size: 32px;
  width: 32px;
  height: 32px;
  color: #cbd5e1;
}
.gf-file-preview {
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: 10px;
  overflow: hidden;
  background: #f8fafc;
}
.gf-file-preview img {
  display: block;
  max-width: 100%;
  max-height: 520px;
  margin: 0 auto;
  object-fit: contain;
}
.gf-file-preview iframe {
  display: block;
  width: 100%;
  height: 600px;
  border: 0;
}
@media (max-width: 992px) {
  .pf-side-by-side {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 768px) {
  .ef-header {
    padding: 10px 14px;
    gap: 10px;
  }
  .ef-body {
    padding: 10px 12px;
  }
  .pf-grid-2 {
    grid-template-columns: 1fr;
  }
  .gf-file-preview iframe {
    height: 420px;
  }
}
@media (max-width: 600px) {
  .pf-header-actions {
    width: 100%;
    justify-content: flex-end;
  }
  .gf-file-actions {
    width: 100%;
  }
  .gf-file-actions .gf-btn {
    flex: 1 1 auto;
  }
}
/*# sourceMappingURL=grant-form.component.css.map */
